export default __webpack_public_path__ + "static/media/vehicle.3ddb2bf7b60d1349514c59aee407d0a8.svg";